export const PROMOCODES = [
  'GABENLOVE',
  'MTS_FREE',
  'PARIVISION',
  'NIX',
  'SOLO',
  'DREAD',
  'MTS2WIN',
  'MAJOR',
  'SANTA',
  'PREMIUM_STEAM',
  'FEB23',
  'STEAMFREE',
  'VIDEO',
  'CYBERPUNK',
  'TI2026',
  'COLIZEUM',
  'STEAMBONUS',
  'RAIN',
  'CLUB',
  'RIDE2PLAY',
]

export const PROMOCODES_FROM_2K = ['MTS_HAPPY']

export const WIDGET_PROMOODE = '2KMTS'

export const PUBG_GENSHIN_WIDGET_PROMOODE = 'LUNA'
